import SoftwarePageTemplate from "@/components/templates/SoftwarePageTemplate";
import { getSoftwareServerSideProps } from "@/libs/getSoftwareServerSideProps";
import { GetServerSidePropsContext } from "next";
import LiveHeroSection from "@/v2-components/pages/software/components/live/live-hero-section";
import LiveClipsSection from "@/v2-components/pages/software/components/live/live-clips-section";
import LiveStepsSection from "@/v2-components/pages/software/components/live/live-steps-section";
import LiveInstallSection from "@/v2-components/pages/software/components/live/live-install-section";
import LiveContentSection from "@/v2-components/pages/software/components/live/live-content-section";
import LiveInteractionSection from "@/v2-components/pages/software/components/live/live-interaction-section";
import LiveSimulationSection from "@/v2-components/pages/software/components/live/live-simulation-section";
import LiveProductsSection from "@/v2-components/pages/software/components/live/live-products-section";
import LiveFaqSection from "@/v2-components/pages/software/components/live/live-faq-section";
import LiveFeedbackSection from "@/v2-components/pages/software/components/live/live-feedback-section";

const LivePage = ({ countryCode }: { countryCode: string }) => {
  return (
    <SoftwarePageTemplate>
      <SoftwarePageTemplate.Content countryCode={countryCode}>
        <LiveHeroSection />
        <div className="relative flex w-full flex-col gap-[64px] bg-white md:gap-[96px]">
          <LiveClipsSection />
          <LiveStepsSection />
          <LiveInstallSection />
          <LiveContentSection />
          <LiveInteractionSection />
          <LiveSimulationSection />
          <LiveProductsSection />
          <LiveFeedbackSection />
          <LiveFaqSection />
        </div>
      </SoftwarePageTemplate.Content>
    </SoftwarePageTemplate>
  );
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  return getSoftwareServerSideProps(ctx);
}

export default LivePage;
